import { useAuth0 } from "@auth0/auth0-react";
import SidebarNavLink from "../SidebarNavLink/SidebarNavLink";
import "./SidebarFooter.css";
import { IconLogout } from "@tabler/icons-react";
import { useConfigContext } from "../../../contexts/ConfigContext/ConfigContextProvider";

export default function SidebarFooter() {
   const { logout } = useAuth0();
   const { jsonTexts, jsonBranding } = useConfigContext();
   const texts = jsonTexts?.sidebar

   const logoutUrl = jsonBranding?.campusUrl;

   return (
      <footer className="sidebar-footer-container">
         <SidebarNavLink
            icon={<IconLogout className="sidebar-navLink--icon" />}
            isButton
            text={texts.cerrarSesion}
            onClick={() => logout({ returnTo: logoutUrl })}
         />
      </footer>
   );
}
